// Generated by tools/card-packs.ts from assets/cards/napoletane; edit the source, not this. Napoletane:
// Supplied by the owner on 2026-09-25; the Neapolitan pattern, one sheet of 40 (Florixc (Wikimedia Commons), Public domain).
import type { CardPack } from '../packs.ts';

export const NAPOLETANE_PACK = {
  name: 'napoletane',
  label: 'Napoletane',
  back: { kind: 'none' },
  decks: {
    italian40: {
      kind: 'files',
      dir: '../../shared/cards/napoletane/italian40',
      ext: 'jpg',
      widths: [120, 240],
      ids: ['AC', '2C', '3C', '4C', '5C', '6C', '7C', 'FC', 'CC', 'RC', 'AD', '2D', '3D', '4D', '5D', '6D', '7D', 'FD', 'CD', 'RD', 'AS', '2S', '3S', '4S', '5S', '6S', '7S', 'FS', 'CS', 'RS', 'AB', '2B', '3B', '4B', '5B', '6B', '7B', 'FB', 'CB', 'RB'],
      aspect: 0.577,
      card: { w: 51, h: 83 },
      inset: 0,
      indices: 'overlay',
    },
  },
  attribution: {
    author: 'Florixc (Wikimedia Commons)',
    sourceUrl: 'https://commons.wikimedia.org/wiki/File:Carte_napoletane_al_completo.jpg',
    licence: 'Public domain',
    licenceUrl: 'https://commons.wikimedia.org/wiki/Template:PD-old-70',
    note: 'Supplied by the owner on 2026-09-25; the Neapolitan pattern, one sheet of 40',
  },
} as const satisfies CardPack;
